import signalr from '@/f1/service/signalr';
import uuid from 'uuid/v1';

let vaild  = ["setting.test", "pong", "status", "resource"]
let resolveMapWS = {};

const WS = {
  Cmd(cmd = undefined, agent_id="", body) {
    return new Promise((resolve, reject) => {
      try {
        let UUID = "";
        if(agent_id == "undefined") { resolve("") }
        else if(cmd.indexOf("_") > -1) { UUID  = `${WS.user_id}.${cmd.split("_")[0]}` }
        else if(cmd === "ping") { UUID  = `${WS.user_id}.pong` }
        else if(cmd === "start") { UUID  = `result` }
        else { UUID  = `${WS.user_id}.${cmd}` }
        resolveMapWS[`${UUID}.${agent_id}`] = { resolve, reject };
        // console.log('signalr.socket()', signalr.socket())
        // location.hostname == "localhost" ? console.log("req", `${UUID}`, agent_id) : '';
        return signalr.invoke('webcastle', { app_id: 'webcastle', cmd : `${cmd}.${agent_id}`,  body : body });
      } catch (e) { console.log(e); reject(e); }
    });
  },
  user_id : "WS."+uuid()
}


signalr.subscribe('webcastle', (response) => {
  try {
    if(!response || !response.cmd) { return; }

    try { if(response.cmd != "pong" && response.cmd != "resource") { response.body = typeof response.body == typeof "string" ? JSON.parse(response.body) : response.body; } }
    catch(e) {
      console.log(e, response)
      console.log("parser error or from data mq version");
      return;
    }
    if(response.cmd != 'list' && (!response || response.body == null)) { console.log("result null or error"); return; }
    // console.log(response, 'response', response.cmd)
    // agent_id 어느 에이전트에 대한 것인지 바인딩 필요

    let cmd = `${WS.user_id}.${response.cmd}.${response.agent_id}`;

    if(_.filter(vaild, x => response.cmd.indexOf(x) > -1).length < 1) {
      console.log("check cmd", response.cmd, new Date());
      return
    }

    if(resolveMapWS[cmd]) {
      // location.hostname == "localhost" ? console.log("webcastle ws", "cmd", `${response.cmd}`, response) : '';
      resolveMapWS[cmd].resolve(response);
      delete resolveMapWS[cmd];
      return
    }

    if(response.cmd == 'pong' || response.cmd == 'status') {
      return;
    }

    signalr.publish('wsfinder_response', response)
  } catch (e) { console.log(e) }
});
export default WS
